import React from 'react';
import ReactDOM from 'react-dom';
import AbstractReactComponent from './../AbstractReactComponent';
import {Dropdown, DropdownToggle, DropdownMenu} from 'reactstrap';
import classNames from 'classnames';
import './FixedDropDownButton.less';

// TODO [R: dokumentace]
class FixedDropDownButton extends AbstractReactComponent {
    // TODO [R: dokumentace]
    static PropTypes = {
        disabled: React.PropTypes.bool,
        // color: Button.propTypes.color,
        // bsSize: Button.propTypes.bsSize,
        // uncontrolled

        /**
         * true, pokud ma byt sipka dolu
         */
        caret: React.PropTypes.bool,
        title: React.PropTypes.node.isRequired,

        /**
         * Pokud chceme uncontrolled, musíme definovat tyto tři.
         */
        uncontrolled: React.PropTypes.bool,
        isOpen: React.PropTypes.bool,
        toggle: React.PropTypes.func,

        // ...Dropdown.propTypes,
    };

    // TODO [R: dokumentace]
    static defaultProps = {
        disabled: false,
        pullRight: false,
        dropup: false,
        navItem: false,
        caret: false,
        uncontrolled: false
    };

    constructor(props) {
        super(props);

        this.state = {
            top: 0,
            left: 0,
            dropdownOpen: props.uncontrolled ? props.isOpen : false
        }
    }

    setSizes = () => {
        const node = ReactDOM.findDOMNode(this.refs.dropdown);
        // const rect = node.getBoundingClientRect();
        const rect = node.getBoundingClientRect();
        const ww = window.innerWidth;
        const wh = window.innerHeight;

        // Výška položek menu
        const menuNode = this.menuNode;
        const currentClassName = menuNode.className;
        menuNode.className = currentClassName + " show-compute";
        const menuHeight = menuNode.offsetHeight;
        const menuWidth = menuNode.offsetWidth;
        menuNode.className = currentClassName;

        const PADDING = 10;

        // Spočtení umístění menu
        let top;
        let left;
        let styles = {};
        if (rect.bottom + menuHeight > wh) {    // nevejde se dolu, dáme ho nahoru
            if (wh < (menuHeight + 2*PADDING)) {
                styles.height = (wh - 2*PADDING) + 'px';
                styles.overflow = 'auto';
                top = PADDING;
            } else {
                top = wh - menuHeight - PADDING;
            }
        } else {    // dáme ho dolu
            top = rect.bottom;
        }

        if (rect.left + menuWidth > ww) {   // nevejde se vpravo, dáme ho vlevo
            left = rect.right - menuWidth;
        } else {    // dáme ho vpravo
            left = rect.left;
        }

        this.setState({
            top,
            left,
            styles
        });
    };

    toggle = () => {
        // console.log("###toggle");
        const {dropdownOpen} = this.state;

        if (dropdownOpen && this.shouldHideOnToggle) {
            this.shouldHideOnToggle = false;
            this.hide();
            return;
        }

        // Slouží pouze pro zobrazení, pokud byl skrytý
        if (!dropdownOpen) {    // je zavřený, otevřeme jej
            const newState = {
                dropdownOpen: true,
                styles: {}
            };

            this.setState(newState, () => {
                const {onToggle} = this.props;

                // --

                const node = ReactDOM.findDOMNode(this.refs.dropdown);
                const dropMenu = node.parentNode.childNodes;

                // console.log("SHOW");
                const menuNode = dropMenu[1];
                this.menuNode = menuNode;
                this.menuNodeClassName = menuNode.className;
                menuNode.className =  menuNode.className + " show";
                document.body.appendChild(menuNode);

                // --

                onToggle && onToggle(true);
                this.setSizes();
            });
        }
    };

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickDown);
        if (this.props.dropdownOpen) {
            this.toggle();
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.uncontrolled) {
            if (this.state.dropdownOpen !== nextProps.isOpen) {
                this.shouldHideOnToggle = true;
                this.toggle();
            }
        }
    }


    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickDown);
    }

    hide = () => {
        // console.log("###hide");
        const {dropdownOpen} = this.state;
        if (!dropdownOpen) {
            return;
        }

        const newState = {dropdownOpen: false}

        this.setState(newState, () => {
            const {onToggle} = this.props;

            // --

            if (this.menuNode !== null) {
                const node = ReactDOM.findDOMNode(this.refs.dropdown);
                // console.log("HIDE");
                this.menuNode.className =  this.menuNodeClassName;
                node.parentNode.appendChild(this.menuNode);
                this.menuNode = null;

                // --

                onToggle && onToggle(false);
            }
        });
    };

    handleKeyDown = (e) => {
        // console.log("###handleKeyDown");
        const {dropdownOpen} = this.state;

        if (!dropdownOpen) {
            return;
        }

        const en = this.findEventNodes(e);
        if (en.foundMenu) {
            this.shouldHideOnToggle = true;
        } else if (en.foundDropdown) {
            // nic
        } else {
            // nic
        }
    };

    findEventNodes = (e) => {
        const node = ReactDOM.findDOMNode(this.refs.main);

        let source = e.target;
        let foundMenu = false;
        let foundDropdown = false;
        while (source && (!foundDropdown ||  !foundMenu)) {
            if (!foundDropdown && source === node) {  // kliknul někam do dropdown
                foundDropdown = true;
            }
            if (!foundMenu && source === this.menuNode) {  // kliknul někam do menu
                foundMenu = true;
            }
            source = source.parentNode;
        }

        return {
            foundMenu,
            foundDropdown
        };
    };

    handleClickDown = (e) => {
        const {uncontrolled, toggle} = this.props;

        // console.log("###handleClickDown");
        const {dropdownOpen} = this.state;

        if (!dropdownOpen) {
            return;
        }

        if (e.which == 3) {  // vždy zavřeme
            if (uncontrolled) {
                toggle();
            } else {
                this.hide();
            }
            return;
        }

        const en = this.findEventNodes(e);
        if (en.foundMenu) {
            this.shouldHideOnToggle = true;
        } else if (en.foundDropdown) {
            // nic
        } else {
            if (uncontrolled) {
                toggle();
            } else {
                this.hide();
            }
        }
    };

    handleDropdownToggle = (e) => {
        const {uncontrolled} = this.props;

        if (uncontrolled) {
        } else {
            const {dropdownOpen} = this.state;
            // console.log("###handleDropdownToggle", dropdownOpen, this.shouldHideOnToggle);
            if (dropdownOpen && this.shouldHideOnToggle) {
                this.shouldHideOnToggle = false;
                this.hide();
            }
        }
    };

    handleToggle = (e) => {
        const {uncontrolled, toggle} = this.props;

        if (uncontrolled) {
            e.stopPropagation();    // nechceme posílat dál, aby se např. nevyvolala událost onClick na komponentě, na které je tento prvek
            e.preventDefault();
            toggle();
        } else {
            // console.log("###handleToggle");
            const {dropdownOpen} = this.state;

            e.stopPropagation();    // nechceme posílat dál, aby se např. nevyvolala událost onClick na komponentě, na které je tento prvek
            e.preventDefault();

            if (dropdownOpen) {
                this.hide();
            } else {
                this.toggle();
            }
        }
    };

    render() {
        let { disabled, color } = this.props;
        let { className, caret, title, children, ...props } = this.props;
        let { top, left, styles } = this.state;

        let dropdownProps = {};
        let toggleProps = {};

        const style = {
            'top': top + "px",
            'left': left + "px",
            ...styles
        };

        const cls = classNames(
            "fixed-dropdown",
            className
        );

        return (
            <Dropdown
                ref="main"
                className={cls}
                {...dropdownProps}
                isOpen={this.state.dropdownOpen}
                toggle={this.handleDropdownToggle}
            >
                <DropdownToggle
                    {...toggleProps}
                    ref='dropdown'
                    caret={caret}
                    color={color}
                    disabled={disabled}
                    onClick={this.handleToggle}
                >
                    {title}
                </DropdownToggle>
                <DropdownMenu
                    style={style}
                    className="fixed-dropdown-dropdown-menu"
                    onKeyDown={this.handleKeyDown}
                >
                    {children}
                </DropdownMenu>
            </Dropdown>
        );
    }
}

export default FixedDropDownButton;
